<template>
    <div>
        <nav-bar></nav-bar>
        <playlist-view :id="id"></playlist-view>
    </div>
</template>

<script>
    import NavBar from '@/components/shared/NavBar.vue';
    import PlaylistView from '@/components/tracks/PlaylistView.vue';

    export default {
        name: "Playlist",
        components: {
            PlaylistView,
            NavBar
        },
        props: {
            id: String
        }
    }
</script>

<style scoped>

</style>
